import Image from 'next/image'
import { useTranslation } from '@mc/i18n'
import { TrackingContainer } from '@mc/visibility'
import { trackMadeForLifelongLearnerViewed } from '../events'
import { HP_INNOVATIVE_SWING_I18N_NAMESPACE } from '../i18n'

export const MadeForLifelongLearner = ({
  customTitle,
  customTrackSectionViewed,
}: {
  customTitle?: React.ReactNode
  customTrackSectionViewed?: () => void
}) => {
  const { t } = useTranslation(HP_INNOVATIVE_SWING_I18N_NAMESPACE)
  const defaultTitle = t('madeForLifelongLearner.title')

  const defaultTitleElement = (
    <h2 className='mc-text-h2 mc-text--center mc-mb-9'>{`${defaultTitle}.`}</h2>
  )

  const handleFirstVisible = () => {
    trackMadeForLifelongLearnerViewed(defaultTitle)
  }

  return (
    <section className='container mc-my-10'>
      <TrackingContainer
        config={{ threshold: 0.3 }}
        onFirstVisible={customTrackSectionViewed || handleFirstVisible}
      >
        {customTitle || defaultTitleElement}
        <div className='d-flex flex-column justify-content-center flex-sm-row flex-sm-wrap flex-lg-nowrap flex-gap-2 flex-gap-sm-3'>
          <LifelongLearnerTile name='instructor' />
          <LifelongLearnerTile name='progress' />
          <LifelongLearnerTile name='anywhere' />
        </div>
      </TrackingContainer>
    </section>
  )
}

const IMAGES = {
  anywhere: 'https://static.masterclass.com/learner-anytime-anywhere.png',
  instructor: 'https://static.masterclass.com/learner-instructors_1.5x.png',
  progress: 'https://static.masterclass.com/pen5690/learner-moments.png',
} as const

const LifelongLearnerTile = ({
  name,
}: {
  name: 'instructor' | 'progress' | 'anywhere'
}) => {
  const { t } = useTranslation(HP_INNOVATIVE_SWING_I18N_NAMESPACE)

  const image = IMAGES[name]

  return (
    <div
      className='position-relative'
      style={{ aspectRatio: '2 / 2.75', flexBasis: '48%' }}
    >
      <Image
        src={image}
        alt=''
        fill
        style={{ objectFit: 'cover' }}
        className='position-absolute mc-corners--md'
        sizes='(max-width: 767px) 350px, 33vw'
      />
      {/* Text overlay with semi-transparent background */}
      <div className='position-absolute mc-inset-0 d-flex flex-column mc-p-4 mc-mb-5'>
        <h3 className='mc-text--small mc-opacity--hinted'>
          {t(`madeForLifelongLearner.tiles.${name}.hint`)}
        </h3>
        <p className='mc-mb-0 mc-text-h4 flex-grow-1 align-content-end mc-text--center'>
          <span className='mc-opacity--hinted'>
            {t(`madeForLifelongLearner.tiles.${name}.line1`)}
          </span>
          <br />
          <span>{t(`madeForLifelongLearner.tiles.${name}.line2`)}</span>
        </p>
      </div>
    </div>
  )
}
